<script >
import servicesRequest from '../../component/cdevs/servicesRequest/index.vue'

export default {
  components:{
    servicesRequest
  }
}
</script>

<template>
  <div class="p-6 all">
    <div>
      <servicesRequest />
    </div>
  </div>
</template>

<style scoped>
.all{
  min-height: 100vh;
}
</style>
